module.exports = __webpack_public_path__ + "img/jobshark-jobs-job-board.73e2e619.jpg";